// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import {
  NormalGroupSupervisoryStatus,
  NormalGroupSupervisoryStatusT,
} from "./normal-group-supervisory-status";
import {
  ValuedGroupSupervisoryStatus,
  ValuedGroupSupervisoryStatusT,
} from "./valued-group-supervisory-status";

export enum GroupSupervisoryStatusVariant {
  NONE = 0,
  NormalGroupSupervisoryStatus = 1,
  ValuedGroupSupervisoryStatus = 2,
}

export function unionToGroupSupervisoryStatusVariant(
  type: GroupSupervisoryStatusVariant,
  accessor: (
    obj: NormalGroupSupervisoryStatus | ValuedGroupSupervisoryStatus,
  ) => NormalGroupSupervisoryStatus | ValuedGroupSupervisoryStatus | null,
): NormalGroupSupervisoryStatus | ValuedGroupSupervisoryStatus | null {
  switch (GroupSupervisoryStatusVariant[type]) {
    case "NONE":
      return null;
    case "NormalGroupSupervisoryStatus":
      return accessor(new NormalGroupSupervisoryStatus())! as NormalGroupSupervisoryStatus;
    case "ValuedGroupSupervisoryStatus":
      return accessor(new ValuedGroupSupervisoryStatus())! as ValuedGroupSupervisoryStatus;
    default:
      return null;
  }
}

export function unionListToGroupSupervisoryStatusVariant(
  type: GroupSupervisoryStatusVariant,
  accessor: (
    index: number,
    obj: NormalGroupSupervisoryStatus | ValuedGroupSupervisoryStatus,
  ) => NormalGroupSupervisoryStatus | ValuedGroupSupervisoryStatus | null,
  index: number,
): NormalGroupSupervisoryStatus | ValuedGroupSupervisoryStatus | null {
  switch (GroupSupervisoryStatusVariant[type]) {
    case "NONE":
      return null;
    case "NormalGroupSupervisoryStatus":
      return accessor(index, new NormalGroupSupervisoryStatus())! as NormalGroupSupervisoryStatus;
    case "ValuedGroupSupervisoryStatus":
      return accessor(index, new ValuedGroupSupervisoryStatus())! as ValuedGroupSupervisoryStatus;
    default:
      return null;
  }
}

export type GroupSupervisoryStatusVariantT =
  | { type: "NONE"; value: null }
  | { type: "NormalGroupSupervisoryStatus"; value: NormalGroupSupervisoryStatusT }
  | { type: "ValuedGroupSupervisoryStatus"; value: ValuedGroupSupervisoryStatusT };
